import { render, staticRenderFns } from "./anchorAfan.vue?vue&type=template&id=e83d1f9a&scoped=true&lang=pug"
import script from "./anchorAfan.vue?vue&type=script&lang=js"
export * from "./anchorAfan.vue?vue&type=script&lang=js"
import style0 from "./anchorAfan.vue?vue&type=style&index=0&id=e83d1f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83d1f9a",
  null
  
)

export default component.exports